import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem("authUser");
    localStorage.removeItem("isLoggedIn");

    navigate("/login");
  }, [navigate]); // add navigate as dependency

  return null;
};

export default Logout;
